<script>
import { percentage_format } from "@/utils.js";
import VueApexCharts from "vue-apexcharts";
export default {
  name: "heatmap-metric",
  props: ["series"],
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      viewOptions: [
        { text: "Year Over Year", value: "yoy" },
        { text: "Year over 2 Years", value: 2}
      ],
      maxRow: 3,
      plusHeight: 30,
      initHeight: 350,
      chartOptions: {
        chart: {
          width: "100%",
          type: "heatmap",
          offSetX: 10000
        },
        xaxis: {
          position: "top",
          labels: {
            formatter: function(value) {
              return value
              // if (value) {
              //   if (typeof value === "string") {
              //     return value.split(" ");
              //   }
              // }
            }
          }
        },
        yaxis: {
          show: true,
          labels: {
            show: true,
            formatter: function (value) {
              return value + '%'
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return `${percentage_format(val)}`;
          }
        },
        plotOptions: {
          heatmap: {
            reverseNegativeShade: true,
            shadeIntensity: 0.5,
            radius: 10,
            useFillColorAsStroke: false,
            colorScale: {
              ranges: [
                {
                  from: -20000000,
                  to: -0.1,
                  color: "#e31b23"
                },
                {
                  from: 0.9,
                  to: 20000000,
                  color: "#00853f"
                },
                {
                  from: 0,
                  to: 0.9,
                  color: "#666666"
                }
              ]
            }
          }
        },
        legend: {
          show: false
        }
      }
    };
  },
  mounted() {
    // console.log("this.series", this.series);
    if (this.series && this.series.length > this.maxRow) {
      let diff = this.series.length - this.maxRow;
      // console.log("diff", diff);
      this.initHeight = this.initHeight + diff * this.plusHeight;
    }
  }
};
</script>
<template>
  <div>
    <apexchart
      type="heatmap"
      :height="initHeight"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>
